module.exports = __webpack_public_path__ + "static/predictivePraxis-a246c7cbccd37488a1a000fd713cd803.jpg";